/**
 * The MAHI wordmark — the brand, not the assistant.
 *
 * Deliberately not the orb (MahiRobot/MahiOrb): the orb is the one tappable
 * "talk to MAHI" surface, and it only ever lives where that action actually
 * makes sense (today, the bottom of Discover). This is a masthead, meant to
 * appear consistently wherever a MAHI screen has a header — Discover today,
 * more pages later — so it lives in components/ui rather than inside any one
 * feature: the next page that needs it should import this one, not a copy.
 *
 * Renders the shared <MahiLogo/> mark (components/ui/MahiLogo) rather than
 * setting "MAHI" in a font, so the letterforms — crucially, the A as a bare
 * inverted-V with no crossbar — stay exact regardless of what typeface a
 * browser/OS substitutes. Don't fork it for a one-off tweak on a single page;
 * change it here so every page stays in sync.
 *
 * `onClick` defaults to "go to Discover" (standard logo-goes-home), since
 * that's correct for every page except Discover itself, which passes its own
 * handler (clearing the active MAHI chip/filter and resetting the feed, not
 * just navigating to a page it's already on).
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import MahiLogo from './MahiLogo';

export default function MahiWordmark({ onClick }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) onClick();
    else navigate('/discover');
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="MAHI, go to discover"
      data-testid="mahi-wordmark"
      className="text-slate-700 leading-none active:opacity-60 transition-opacity"
    >
      <MahiLogo className="h-[18px] w-auto" decorative />
    </button>
  );
}
